import { Column, TABLE_ACTION, defaultColDef, defaultColActionDef, formatter } from '@qrios/frontend-library';

import locales from '../../../../../../constants/commonLocales';
import { predefinedColumns } from '../../../../../common/table/columns/predefinedColumns';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: locales.table.column.operationId,
    flex: 2,
    minWidth: 150
  },
  predefinedColumns.date({}),
  {
    ...defaultColDef,
    field: 'customerMsisdn',
    headerName: locales.table.column.customerMsisdn,
    flex: 2
  },
  predefinedColumns.status({}),
  {
    ...defaultColDef,
    field: 'merchantCode',
    headerName: locales.table.column.merchant_code,
    flex: 2
  },
  {
    ...defaultColDef,
    field: 'amount',
    headerName: locales.table.column.amount,
    flex: 1,
    valueFormatter: formatter.amountFormatter
  },
  predefinedColumns.cost({}),
  {
    ...defaultColActionDef(ACTIONS)
  }
];
